let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lTjvS")).then(() => parcelRequire('aY2UQ'));